// extracted by mini-css-extract-plugin
export var confirmationHeader = "_wu-0";
export var confirmationIcon = "_wu-1";